import { type FC } from 'react';
import { Button, Stack, Text } from '@chakra-ui/react';
import { translate } from '../../../constants/translation';
import { ActionType } from '../../GlobalContextProvider/global-reducer';
import { useDispatch, useTripsContext } from '../../GlobalContextProvider/GlobalContextProvider';
import { useAppInsights } from '../../../hooks/useAppInsights';
import { getEventFactory } from '../../../utils/get-event-factory';
import { Event, Feature, type Page } from '../../../types';
import { getFilters } from '../../GlobalContextProvider/utils/context-utils';

interface Props {
  page: Page;
}

const NoTripsFound: FC<Props> = ({ page }) => {
  const tripsDispatch = useDispatch();
  const context = useTripsContext();
  const appInsights = useAppInsights();

  const resetFilters = (): void => {
    tripsDispatch({ type: ActionType.RESET_FILTER });
    const event = getEventFactory(Event.FiltersReset)(Feature.TripsHistoryPanel, page, getFilters(context));
    appInsights.trackAnalyticsEvent(event);
  };

  return (
    <Stack className="no-trips-container" spacing="3">
      <Text className="text-header">{translate('NO_TRIPS')}</Text>
      <Text textAlign="center">{translate('NO_MATCH_ON_SEARCH')}</Text>
      <Button variant="secondary" onClick={resetFilters}>
        {translate('CLEAR_SEARCH')}
      </Button>
    </Stack>
  );
};

export default NoTripsFound;
